export const loadFromLocalStorage = (key: string) => {
  try {
      const value = localStorage.getItem(key);
      if (value === null) return undefined;
      return value;
  } catch (error) {
      console.error('Error loading from local storage', error);
      return undefined;
  }
};